import styled from 'styled-components'

const ContactStyle = styled.div.attrs({ className: 'contact' })`
	--imgSize: var(--sp81x);

	.contact-page {
		

		&-block {
			display: flex;
			flex-direction: column;

			.top-section {
				display: flex;
				justify-content: space-between;

				.title {
					max-width: var(--sp81x);
					width: 100%;
				}

				.description {
					max-width: var(--sp98x);
					width: 100%;
					margin-left: var(--sp21x);
				}
			}

			.main-section {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-top: var(--pageFromHeaderMargin);
				position: relative;

				&:after {
					content: '';
					position: absolute;
					top: 0;
					bottom: 0;
					left: 0;
					width: calc(var(--imgSize) / 2);
					background-color: var(--white);
				}

				.img {
					position: relative;
					z-index: 1;
					max-width: var(--imgSize);
					width: 40.25%;
					border-radius: 50%;
					overflow: hidden;
					transform: scale(0);
					.imageCont {
						width: 100%;
						padding-top: 100%;
						transform: scale(3);
						> * {
							top: -10% !important;
							left: -10% !important;
							height: 120%;
							width: 120%;
						}
					}
				}

				.info {
					display: flex;
					justify-content: space-between;
					margin-left: var(--sp21x);
					max-width: var(--sp98x);
					width: 100%;
					flex: 1;

					.content {
						max-width: var(--sp60x);
						width: 100%;
						display: flex;
						flex-direction: column;

						.single-info {
							display: flex;
							flex-direction: column;
							transform: translateX(-90vw);

							&:last-child {
								margin-top: var(--sp19x);
							}

							.title {
								margin-bottom: var(--titleFromContent);
							}
						}
					}

					.social {
						display: flex;
						flex-direction: column;
						transform: translateX(-90vw);

						a {
							&:not(:last-child) {
								margin-bottom: var(--sp5x);
							}

							i {
								font-size: var(--sp10x);
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeM}) {
		--imgSize: var(--sp72x);
		.contact-page {
			&-block {
				.top-section {
					.title {
						max-width: var(--sp68x);
					}

					.description {
						max-width: var(--sp83x);
						margin-left: var(--sp18x);
					}
				}

				.main-section {
					.img {
						width: 42.5%;
					}

					.info {
						margin-left: var(--sp15x);
						max-width: var(--sp83x);

						.content {
							max-width: var(--sp50x);

							.single-info {
								&:last-child {
									margin-top: var(--sp11x);
								}
							}
						}

						.social {
							a {
								&:not(:last-child) {
									margin-bottom: var(--sp4x);
								}

								i {
									font-size: var(--sp7x);
								}
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeS}) {
		--imgSize: var(--sp68x);
		.contact-page {
			&-block {
				max-width: 1130px;
				.top-section {
					.title {
						max-width: var(--sp68x);
					}

					.description {
						max-width: var(--sp68x);
						margin-left: var(--sp4x);
					}
				}

				.main-section {
					.img {
						width: 48.45%;
					}

					.info {
						margin-left: var(--sp4x);
						max-width: var(--sp68x);

						.content {
							max-width: 352px;

							.single-info {
								&:last-child {
									margin-top: var(--sp13x);
								}
							}
						}

						.social {
							a {
								&:not(:last-child) {
									margin-bottom: var(--sp3x);
								}

								i {
									font-size: var(--sp5x);
								}
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.TabletSize}) {
		--imgSize: var(--sp57x);
		.contact-page {
			&-block {
				.top-section {
					flex-direction: column;

					.title {
						max-width: unset;
						margin-bottom: var(--sp2-5x);
					}

					.description {
						max-width: unset;
						margin-left: 0;
					}
				}

				.main-section {
					.img {
						@media screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) {
							max-width: var(--sp42x);
						}

						width: 48.45%;
					}

					.info {
						margin-left: var(--sp3x);
						max-width: var(--sp68-5x);
						flex: 1;

						.content {
							max-width: var(--sp44x);

							.single-info {
								&:last-child {
									margin-top: var(--sp13x);

									@media screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) {
										margin-top: var(--sp9x);
									}
								}
							}
						}

						.social {
							a {
								&:not(:last-child) {
									margin-bottom: var(--sp3x);
								}

								i {
									font-size: var(--sp7x);
								}
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		--imgSize: unset;
		.contact-page {
			&-block {
				.top-section {
					flex-direction: column;

					.title {
						max-width: unset;
						margin-bottom: var(--sp3x);
					}

					.description {
						max-width: unset;
						margin-left: 0;
					}
				}

				.main-section {
					flex-direction: column;
					margin-top: var(--sp3x);

					.img {
						max-width: unset;
						width: 100%;
						margin-bottom: var(--sp3x);
					}

					.info {
						margin-left: 0;
						max-width: unset;
						flex: 1;

						.content {
							max-width: var(--sp31x);

							.single-info {
								&:last-child {
									margin-top: var(--sp10x);
								}
							}
						}

						.social {
							a {
								&:not(:last-child) {
									margin-bottom: var(--sp2x);
								}

								i {
									font-size: var(--sp7x);
								}
							}
						}
					}
				}
			}
		}
	}
`
export default ContactStyle
